module.exports = __webpack_public_path__ + "images/emoji/tennis.eedbf99de853aad340af.png";